import React, { createContext, useContext, useEffect, useState } from 'react'
import { login as apiLogin } from '../api/auth'
import { getProfile } from '../api/account'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [token, setToken] = useState(localStorage.getItem('token') || null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const stored = localStorage.getItem('user')
    if (token && stored) setUser(JSON.parse(stored))
    setLoading(false)
  }, [token])

  const login = async ({ email, username, password }) => {
    const usernameOrEmail = email || username
    const { token: jwt } = await apiLogin({ usernameOrEmail, password })
    localStorage.setItem('token', jwt)
    setToken(jwt)

    let me = null
    try { me = await getProfile() } catch { /* */ }
    if (me) {
      localStorage.setItem('user', JSON.stringify(me))
      setUser(me)
    }
    return me
  }

  const logout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    setToken(null)
    setUser(null)
  }

  const updateAvatar = (url) => {
    setUser((u) => {
      const next = { ...(u || {}), profileImageUrl: url }
      localStorage.setItem('user', JSON.stringify(next))
      return next
    })
  }

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout, setUser, updateAvatar }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
